import { pipe, pickBy, toPairs, map, join, values, sum, keys } from 'ramda';
import { IntlShape } from 'react-intl';
import { ReferenceType } from '../enums/ReferenceType';
import { IRefReqCounters } from '../models/referenceRequest/IRefReqCounters';

export const getStep3Text = (refCounters: IRefReqCounters, intl: IntlShape) => pipe<
  Record<keyof IRefReqCounters, number>,
  Record<string, number>,
  [string, number][],
  string[],
  string
>(
  pickBy((val, key) => key !== 'totalCount' && val > 0),
  toPairs,
  map(([key, value]) => `${value} ${intl.formatMessage({
    id: `review.${key}.${value === 1 ? 'one' : 'many'}`,
    defaultMessage: key
  }, { key })}`),
  join(', ')
)(refCounters);

export const getCountersSum = (counters: IRefReqCounters) => pipe<IRefReqCounters, IRefReqCounters, number[], number>(
  pickBy((val, key) => key !== 'totalCount'),
  values,
  sum
)(counters);

export const refCounterTypes = {
  managersCount: ReferenceType.Manager,
  peersCount: ReferenceType.Peer,
  subordinatesCount: ReferenceType.Subordinate,
  educatorsCount: ReferenceType.Educator,
  othersCount: ReferenceType.Other
} as Record<keyof IRefReqCounters, ReferenceType>;

export const simpleRequestCounters = {
  managersCount: 0,
  peersCount: 0,
  subordinatesCount: 0,
  educatorsCount: 0,
  othersCount: 0
};

export const refTypes: (keyof IRefReqCounters)[] = keys(refCounterTypes);
